import styles from './styles.scss';
import Button from 'Components/Button';
import React from 'react';
import classNames from 'classnames/bind';
import { CarImage } from './CarImage';

const cx = classNames.bind(styles);

const Footer = ({
  model,
  goBack,
  goNext,
  transferData,
  loading,
  hasShadow,
  showSmallCarIn,
  showSmallCarOut,
  activeStep,
  lastStep,
  nextEnabled,
}) => (
  <div className={cx(styles.footer, hasShadow && styles.shadow)}>
    <div>
      {activeStep === lastStep ? (
        <Button
          onClick={transferData}
          label="Absenden"
          small
          disabled={loading || !nextEnabled}
          ariaLabel={loading || !nextEnabled ? undefined : 'Formular absenden'}
          className={styles.nextButton}
        />
      ) : (
        <Button
          onClick={goNext}
          label="Weiter"
          disabled={!nextEnabled}
          ariaLabel={!nextEnabled ? undefined : 'Gehe zum nächsten Schritt'}
          className={styles.nextButton}
          small
        />
      )}
    </div>
    {showSmallCarOut && <CarImage carIn="" carOut={model} small />}
    {showSmallCarIn && <CarImage carIn={model} carOut="" small />}
    <div>
      {lastStep > 0 && (
        <Button
          onClick={goBack}
          icon="backward"
          className={styles.backButton}
          disabled={activeStep === 0}
          ariaLabel="Gehe einen Schritt zurück"
          name="Zurück"
        />
      )}
    </div>
  </div>
);

export { Footer };
